














































































































































































import RichTextEditor from "@/components/misc/RichTextEditor.vue";
import { Component, Model, Ref, Vue, Watch } from "vue-property-decorator";
import FormDescription from "@/components/misc/FormDescription.vue";
import { DocumentSettingsType } from "@/store/modules/documents";
import { Notification } from "@/store/modules/notifications";

@Component({ components: { FormDescription,RichTextEditor } })
export default class DocumentSettingsForm extends Vue {
  @Ref("form") formRef?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };


  @Model() model?: DocumentSettingsType;

  get isLocked() {
    return false;
  }

  @Watch('model')
  onModelLoad(model: DocumentSettingsType, oldModel: DocumentSettingsType | null | undefined)
  {
    if(oldModel === null || oldModel === undefined)
    {
      this.loadPhoto();
    }
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      maxLength: (max: number) => (v: string) =>
        !v || (v.length <= max) ||
        this.$t("Validation.MaxLength", { count: max }),
    };
  }

  // photos
  savingPhoto = false;
  dragging = false;
  filesToUpload: any = {};
  photoSrc: any = "";

  addPhoto() {
    (
      (this.$refs.photoInputRef as Vue).$el.lastElementChild?.firstElementChild
        ?.firstElementChild?.lastElementChild as HTMLElement
    ).click();
  }

  dropPhoto(e: any) {
    this.dragging = false;

    const imageTypeRegex = new RegExp(/image\/*/);

    for (const file of e.dataTransfer.files) {
      if (!imageTypeRegex.test(file.type)) {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("PhotosUpload.NotAllImages"),
          timeout: 5000,
        } as Notification);
        return;
      }
    }
    this.filesToUpload = e.dataTransfer.files;
  }

  @Watch("filesToUpload")
  uploadPhoto() {
    if (this.filesToUpload.length > 1) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("PhotosUpload.CannotUploadMultiplePhotos"),
        timeout: 5000,
      } as Notification);
      return;
    }

    if (!this.filesToUpload || this.filesToUpload.length == 0) {
      return;
    }

    const formData = new FormData();
    if (this.filesToUpload.length) {
      for (let i = 0; i < this.filesToUpload.length; i++) {
        formData.append("logo", this.filesToUpload[i]);
      }
    } else {
      formData.append("logo", this.filesToUpload);
    }

    this.savingPhoto = true;
    Vue.axios
      .post(`tenants/${this.model?.tenantId}/logo`, formData)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("PhotosUpload.Success"),
          timeout: 5000,
        } as Notification);

        if(this.model)
        {
          this.model.hasLogo = true;
          this.loadPhoto();
        }
      })
      .finally(() => (this.savingPhoto = false));
  }

  deletePhotoConfirmation() {
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("PhotoDelete.Confirmation"),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deletePhoto();
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deletePhoto() {
    this.savingPhoto = true;
    Vue.axios
      .delete("tenants/" + this.model?.tenantId + "/logo")
      .then(() => {
        if(this.model)
        {
          this.model.hasLogo = false;
        }
      })
      .catch(() => {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("PhotoDelete.Failed"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.savingPhoto = false;
      });
  }

  loadPhoto() {
    Vue.axios
      .get("system/GetTenantLogo/" + this.model?.tenantId, {
        responseType: "blob",
      })
      .then((res) => {
        const reader = new FileReader();
        reader.readAsDataURL(res.data);
        reader.onload = () => {
          this.photoSrc = reader.result;
        };
      })
      .catch(() => {
        this.photoSrc = require("@/assets/images/no-image-icon-23488.png");
      });
  }
}
